import { parseUrl } from "components/Signup/flow/utils/parseUrlQuery";
import { resumePreviewStore } from "components/Signup/flow/utils/previewStore";
import { StepName } from "components/Signup/steps/types";
import Router from "next/router";
import { selectDraftId } from "../../selectors/metadata";
import { State } from "../../state/types";

export const animalRoutes: Array<StepName> = [
  "animal-access",
  "animal-birthday",
  "animal-sex",
  "breed",
  "castration",
  "mixed-breed",
  "name",
  "species",
  "product",
  "new-or-switch",
  "fetch-current-insurance",
  "fetch-current-insurance-question",
  "choose-animal",
  "cancel-previous-insurance",
  "power-of-attorney",
  "address",
  "previous-claims",
  "cancelled-previously",
] as const;

// These are the routes where we want to go through the animals in a sequential order.
// The id will be removed when navigating to one of these steps so the routing can add back the first animal
export const sequentialAnimalRoutes: Array<StepName> = [
  "health-questions",
  "quote-preview",
  "liability-quote-preview",
  "preventive",
];

const draftPreviewStep: StepName[] = [
  "quote-preview",
  "liability-quote-preview",
];

export const draftSummaryStep: StepName[] = [
  "draft-summary",
  // TODO: Enable after testing
  // "draft-summary-liability",
  // "draft-summary-flytthjalp",
];

export async function updateRoute({
  route,
  state,
  replace,
}: {
  route: StepName | `${StepName}/${string}`;
  state: State;
  replace?: boolean;
}) {
  const isOnDraftStep = draftPreviewStep.includes(
    route.split("/")[0] as StepName
  );

  const draftId = selectDraftId(state);

  if (isOnDraftStep && draftId) {
    resumePreviewStore.save({
      isLiability: state.navigation.activeStep === "liability-quote-preview",
      previewId: draftId,
      name: state.animals[0].name ?? null,
      species: state.animals[0].species ?? null,
      isMultipet: state.animals.length > 1,
    });
  }

  // Preserve id
  const { animalId } = parseUrl(Router.query);

  const pathname = `${route}${
    animalId && animalRoutes.includes(route as StepName) ? `/${animalId}` : ""
  }`;

  const isOnDraftSummaryStep = draftSummaryStep.includes(
    route.split("/")[0] as StepName
  );

  const query =
    (isOnDraftStep || isOnDraftSummaryStep) && draftId
      ? { query: { id: draftId } }
      : {};

  replace
    ? await Router.replace({ pathname, ...query }, undefined, { shallow: true })
    : await Router.push({ pathname, ...query }, undefined, { shallow: true });
}
